<template>
<div class="bg-faintGrey">
    <router-view></router-view>
  </div>
</template>

<style>
</style>
